/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 11/19/20
 * Time: 11:21 AM
 */
import React, {Component} from 'react';
import '../ManageCamera.scss';
import {Row, Col, CardBody, Card, CardHeader} from "reactstrap";
import Lbl from "../../../../../components/Label/Lbl";
import LabelInput from "../../../../../components/Input/Input/TxtLbl";
import {Button, Dropdown, Icon, Input} from 'semantic-ui-react';
import Cookies from "js-cookie";
import * as keys from "../../../../../const/key/Key";
import axiosVisitortags from "../../../../../axios/axios_visitortag";
import axiosTags from "../../../../../axios/axios_tag";
import apiConfig from "../../../../../axios/axios_api_services";
import * as common from "../../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../../store/Action";
import * as validator from "../../../../../util/Validator";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
  cameraPublicIp: "", rtspPort: "", username: "", password: "", channel: "", cameraSuffix: "",branches:[],branchId:'',passwordType: 'password',cameraId:""
};
class App extends Component {
  state = Object.assign({}, initialState);

  handleChange = (name) => event => {
    let value = event.target.value;
    if(name === "cameraPublicIp") if(!validator.keyPressDigitAndDotValidation(value)) return;
    if(name === "rtspPort") if(!validator.portValidation(value)) return;

    this.setState({
      [name]: value
    });
  };

  validationHandler = () => {
    let {cameraPublicIp,rtspPort,username,password,channel,branchId,cameraId} = this.state;
    branchId === "" ? common.notifyMessage("Branch cannot be empty") :
    cameraId.trim() === "" ? common.notifyMessage("Camera Id cannot be empty") :
      !validator.ipAddressValidation(cameraPublicIp) ? common.notifyMessage("Please enter valid public IP address") :
        rtspPort === "" ? common.notifyMessage("RTSP Port cannot be empty") :
          channel.trim() === "" ? common.notifyMessage("Channel cannot be empty") :
            username.trim() === "" ? common.notifyMessage("Username cannot be empty") :
              password.trim() === "" ? common.notifyMessage("Password cannot be empty") :
                swal({
                  title: "Do you want to proceed?",
                  icon: are_you_sure_icon, closeOnClickOutside: false,
                  buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
                })
                  .then((value) => {
                    switch (value) {
                      case "action":
                        this.submitHandler();
                        break;
                      default:
                    }
                  });
  };

  submitHandler = () => {
    const obj = cloneDeep(this.state);
    delete obj.branches;
    delete obj.passwordType;

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitortags.put(apiConfig.IVCA_CORPORATE_BRANCH_CAMERA({corporateId:this.props.usr_obj.corporateId, branchId: obj.branchId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({...initialState})
        }
        common.warningAlert(response.data.message, response.data.success ? 0 : 1);
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.submitHandler();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  getAllBranches = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_WITH_BRANCHES, {headers: headers})
      .then(response => {
        let branches = [];
        if (response.data.success) {
          let result = response.data.body;
          if (result.length !== 0) {
            result.map((resObj, index) => {
              if (resObj.corporateId === this.props.usr_obj.corporateId && resObj.branches.length !== 0) {
                resObj.branches.map((branch, index) => {
                  branches.push({
                    text: branch.name,
                    value: branch.branchId,
                    key: index
                  })

                });
              }
            });
          }
        }
        this.setState({branches});
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranches();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };
  componentWillMount() {
   this.getAllBranches();
  }
  viewPassword = () => {
    let i = document.getElementById("password-field");
    this.setState({passwordType: i.type === "password" ? "text":"password"});
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };
  render() {
    let {branches,branchId,passwordType} = this.state;

    return (
      <Row className={"ivca-create-camera"}>
        <Col lg={2}/>
        <Col>
          <Card>
            <CardHeader>Add Camera Details</CardHeader>
            <CardBody>

              <Row>
                <Col md={7}>
                  <div className={"none-padding"}>
                    <Lbl required>Branch</Lbl>
                    <Dropdown
                      fluid selection search
                      options={branches} value={branchId}
                      placeholder={"Select branch"}
                      onChange={(event, {value}) => {
                        this.setState({branchId: value})
                      }}
                    />
                  </div>
                </Col>
                <Col>
                  <div className={"none-padding"}>
                    <Lbl required>Camera ID</Lbl>
                    <LabelInput
                      placeholder={"Camera ID"}
                      value={this.state.cameraId}
                      onChange={this.handleChange('cameraId')}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={8}>
                  <div className={"none-padding"}>
                    <Lbl required>Public IP</Lbl>
                    <LabelInput
                      placeholder={"Public IP"}
                      value={this.state.cameraPublicIp}
                      onChange={this.handleChange('cameraPublicIp')}
                    />
                  </div>
                </Col>
                <Col>
                  <div className={"none-padding"}>
                    <Lbl required>RTSP Port</Lbl>
                    <LabelInput
                      placeholder={"RTSP Port"}
                      value={this.state.rtspPort}
                      onChange={this.handleChange('rtspPort')}
                    />
                  </div>
                </Col>
              </Row>


              <div className={"none-padding"}>
                <Lbl required>Channel</Lbl>
                <LabelInput
                  placeholder={"Channel"}
                  value={this.state.channel}
                  onChange={this.handleChange('channel')}
                />
              </div>

              <Row>
                <Col md={6}>
                  <div className={"none-padding"}>
                    <Lbl required>Username</Lbl>
                    <LabelInput
                      placeholder={"Username"}
                      value={this.state.username}
                      onChange={this.handleChange('username')}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className={"none-padding"}>
                    <Lbl required>Password</Lbl>
                    <Input id={"password-field"} type={"password"}
                           onChange={this.handleChange('password')}
                           value={this.state.password}
                           style={{width: '100%'}}
                           icon={<Icon onClick={() => this.viewPassword(false)}
                                       onClick={() => this.viewPassword(true)} name={passwordType === "password"?'eye':'eye slash'} circular link/>}
                           placeholder='Password'/>
                  </div>
                </Col>
              </Row>

              <hr/>
              <div className={"none-padding"}>
                <Lbl>Suffix Parameter</Lbl>
                <LabelInput
                  placeholder={"Suffix"}
                  value={this.state.cameraSuffix}
                  onChange={this.handleChange('cameraSuffix')}
                />
              </div>
              <br/>
              <div className={"align-center"}>
                <Button
                  className="px-5"
                  onClick={this.validationHandler}
                >Add Camera</Button>
              </div>

            </CardBody>
          </Card>
        </Col>
        <Col lg={2}/>
      </Row>
    );
  }
}
const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
});
const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
